import { Button } from '@/components/ui';
import { useTranslation } from '@kgc/i18n';
import { Play } from 'lucide-react';
import { useMemo } from 'react';
import { ExecutionRow } from './components/ExecutionRow';
import type { FlowTab, WorkflowExecution } from './types';

interface FlowRunningTabProps {
  executions: WorkflowExecution[];
  onTabChange?: ((tab: FlowTab) => void) | undefined;
}

export function FlowRunningTab({ executions, onTabChange }: FlowRunningTabProps) {
  const { t } = useTranslation();

  const activeExecutions = useMemo(
    () => executions.filter(e => e.status === 'running' || e.status === 'pending'),
    [executions]
  );

  if (activeExecutions.length === 0) {
    return (
      <div
        className="flex flex-col items-center justify-center py-12 text-muted-foreground"
        data-testid="flow-running-empty"
      >
        <Play className="h-12 w-12 mb-3 opacity-50" aria-hidden="true" />
        <p className="text-sm mb-3">{t('integration.flow.running.noExecutions')}</p>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onTabChange?.('catalog')}
          data-testid="flow-running-start-cta"
        >
          {t('integration.flow.running.startOne')}
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {activeExecutions.map(exec => (
        <ExecutionRow key={exec.id} execution={exec} />
      ))}
    </div>
  );
}
